import { useContext } from 'react';
import { IUserInfo } from 'gen/ApiClient';
import { LoggedInUserContext } from './LoggedInUserContext';

export function useLoggedInUser(): IUserInfo {
    const { user } = useContext(LoggedInUserContext);
    return user;
}